<button type="button" (click)="getViewApp()" id="idApp" style="display:none"></button>

<div class="container-fluid">
  <!-- <ngx-loading [show]="pageload"></ngx-loading> -->
  <div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="card border-light shadow-sm">
    <div class="row">
      <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
        <h6>
          <span style="padding-right:10px"></span>
          <b>Permit<a class="red-asterik"> *</a></b> <span style="color:lightgray"> Please add permit type linked to this application</span>
        </h6>
      </div>
    </div>
    <br>
    <div class="col-md-12">

      <br>
      <div>
        <div class="col-sm-6">
          <!-- <h6>
              <span style="padding-right:5px"></span>
              <b>Types & Rates</b>
            </h6>
            <div class="list-group">
                <a *ngFor="let item of permittype, let i=index" href="javascript:void(0);" class="list-group-item-light list-group-item-action flex-column align-items-start" (click)="onSelectType(i,item)">
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{item.code}}</h5>
                    <small>{{item.fee}}</small>
                  </div>
                  <p class="mb-1">{{item.description}}</p>
                  <i *ngIf="selectedIndex === i" class="fa fa-check-circle-o" style="font-size:2em !important; float:right; color:green"></i>
                </a>
              </div> -->



          <div class="form-group ">
            <!-- <h4>Passanger or Freights</h4> -->
            <div class="row">
              <div class="col-sm-6">
                <!-- <div class="icon-left">
                   <img src="assets/passenger.png"/>
                </div> -->
                <div class="radio" *ngIf="!isAmend">
                  <input type="button" class="btn-passenger" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" name="vehicle-type"
                    *ngIf="vehicleType!=2" value="Passenger" ([ngModel])="vehicleType"
                    (click)="selectVehicleType('2')" />
                  <input type="button" class="btn-passenger-active" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" *ngIf="vehicleType==2"
                    name="vehicle-type" value="Passenger" ([ngModel])="vehicleType" (click)="selectVehicleType('2',permitType)" />

                </div>
                <div class="radio" *ngIf="isAmend">
                  <input type="button" class="btn-passenger" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" name="vehicle-type"
                    *ngIf="amendType!=2" value="Passenger" ([ngModel])="amendType"
                    (click)="selectVehicleType('2')" />
                  <input type="button" class="btn-passenger-active" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" *ngIf="amendType==2"
                    name="vehicle-type" value="Passenger" ([ngModel])="amendType" (click)="selectVehicleType('2',permitType)" />

                </div>
              </div>
              <div class="col-sm-6">
                <!-- <div class="icon-right">
                   <img src="assets/Freight.png"/>
                </div> -->
                <div class="radio" *ngIf="!isAmend">
                  <input type="button" class="btn-passenger" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" name="vehicle-type"
                    *ngIf="vehicleType!=1" value="Freight" ([ngModel])="vehicleType" (click)="selectVehicleType('1',permitType)" />
                  <input type="button" class="btn-passenger-active" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" *ngIf="vehicleType==1"
                    name="vehicle-type" value="Freight" ([ngModel])="vehicleType" (click)="selectVehicleType('1')" />

                </div>
                <div class="radio" *ngIf="isAmend">
                  <input type="button" class="btn-passenger" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" name="vehicle-type"
                    *ngIf="amendType!=1" value="Freight" ([ngModel])="amendType" (click)="selectVehicleType('1',permitType)" />
                  <input type="button" class="btn-passenger-active" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" *ngIf="amendType==1"
                    name="vehicle-type" value="Freight" ([ngModel])="amendType" (click)="selectVehicleType('1')" />

                </div>
              </div>
            </div>


          </div>


          <hr>

          <div class="form-group">
            <div class="row">
              <!-- <h4>Temperary or Long-term Permit</h4> -->
              <div class="col-sm-6">
                <!-- <div class="icon-left pl-3" style="height:auto">
                <img src="assets/Temporarypermit.png" style="height:118px;width:118px;">
              </div> -->
                <div class="radio " *ngIf="!isAmend">
                  <input type="button" ([ngModel])="vehicleTerm" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" *ngIf="vehicleTerm!=1"
                    class="btn-passenger" value="Temporary Permit" (click)="selectVehicleTerm('1')"
                    name="vehicle-term" />
                  <input type="button" ([ngModel])="vehicleTerm" [disabled]="permitDisabled  || !isProcess || isDuplicate || upliftment" *ngIf="vehicleTerm==1"
                    class="btn-passenger-active" value="Temporary Permit" (click)="selectVehicleTerm('1')"
                    name="vehicle-term" />

                </div>
                <div class="radio " *ngIf="isAmend">
                  <input type="button" ([ngModel])="amendTerm" [disabled]="permitDisabled || !isProcess || isDuplicate || upliftment" *ngIf="amendTerm!=1"
                    class="btn-passenger" value="Temporary Permit" (click)="selectVehicleTerm('1')"
                    name="vehicle-term" />
                  <input type="button" ([ngModel])="amendTerm" [disabled]="permitDisabled  || !isProcess || isDuplicate || upliftment" *ngIf="amendTerm==1"
                    class="btn-passenger-active" value="Temporary Permit" (click)="selectVehicleTerm('1')"
                    name="vehicle-term" />


                </div>
              </div>
              <div class="col-sm-6">
                <!-- <div class="icon-left pl-4" style="height:auto">
                <img src="assets/Longtermpermit.png" style="height:118px;width:118px;">
              </div> -->
                <div class="radio " *ngIf="!isAmend">
                  <input type="button" class="btn-passenger" [disabled]="permitDisabled  || !isProcess || isDuplicate || upliftment" ([ngModel])="vehicleTerm"
                    *ngIf="vehicleTerm!=2" (click)="selectVehicleTerm('2')" [checked]="vehicleTerm=='2'"
                    value="Long-term Permit" name="vehicle-term" />
                  <input type="button" ([ngModel])="vehicleTerm" [disabled]="permitDisabled  || !isProcess || isDuplicate || upliftment" *ngIf="vehicleTerm==2"
                    class="btn-passenger-active" value=" Long-term Permit" (click)="selectVehicleTerm('2')"
                    name="vehicle-term" />

                </div>
                <div class="radio " *ngIf="isAmend">

                  <input type="button" class="btn-passenger" [disabled]="permitDisabled  || !isProcess || isDuplicate || upliftment" ([ngModel])="amendTerm"
                    *ngIf="amendTerm!=2" (click)="selectVehicleTerm('2')" [checked]="amendTerm=='2'"
                    value="Long-term Permit" name="vehicle-term" />
                  <input type="button" ([ngModel])="amendTerm" [disabled]="permitDisabled  || !isProcess || isDuplicate || upliftment" *ngIf="amendTerm==2"
                    class="btn-passenger-active" value=" Long-term Permit" (click)="selectVehicleTerm('2')"
                    name="vehicle-term" />

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-6">
                <div class="row form-group mt-2">
                  <div>
                    <label><strong>Permit duration<a class="red-asterik"> *</a> </strong></label>
                  </div>
                  <div class="col-sm-8">
                    <select *ngIf="!duration "#durationSelectedRef class="form-control  permit-select" (change)="durationChange(durationSelectedRef)"
                            [disabled]="(!vehicleType && !vehicleTerm) || !isProcess || isDuplicate || upliftment">
                      <option *ngIf="defaultValue == null" [value]="null" [disabled]="true">Select Permit Duration</option>
                      <ng-container *ngFor="let cat of durations | orderBy : ['num_days'] : false" >
                        <option *ngIf="(cat.freight_passenger_ind==vehicleType && cat.temp_long_ind == vehicleTerm)"
                                [ngValue]="cat.duration"  [selected]="cat.duration== durationSelected" >{{cat.duration}}</option>
                      </ng-container>
                    </select>

                    <select *ngIf="duration" #durationSelectedRef class="form-control  permit-select" (change)="durationChange(durationSelectedRef)"
                            [disabled]="(!vehicleType && !vehicleTerm) || !isProcess || isDuplicate || upliftment">                 
                      <option [value]="null" [disabled]="true">{{duration}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="row form-group mt-2">
                  <div>
                    <label><strong>Select Permit Type<a class="red-asterik"> *</a></strong></label>
                  </div>
                  <div class="col-sm-8">
                    <select *ngIf="!duration" class="form-control permit-select" id="idCtype" [compareWith]="compareFunction" (change)="onChange()"
                            [disabled]="(!vehicleType && !vehicleTerm) || permitDisabled || !isProcess || isDuplicate || upliftment" [(ngModel)]="selectedPermit">
                      <option *ngIf="defaultValueType == null" [value]="null || undefined" disabled selected>Select Permit Type</option>
                      <option *ngIf="defaultValueType != null && otherPermitType == true">{{defaultValueType}}</option>
                      <ng-container *ngFor="let cat of permittype">
                        <!-- <option *ngIf="(cat.CanCreatePermit && cat.freight_passenger_ind==vehicleType && cat.temp_long_ind == vehicleTerm && cat.duration == durationSelected)" [ngValue]="cat" >{{cat.description}}</option> -->
                        <option *ngIf="(cat.CanCreatePermit && cat.freight_passenger_ind==vehicleType && cat.temp_long_ind == vehicleTerm && cat.duration == durationSelected)" [ngValue]="cat" >{{cat.description}}</option>
                      </ng-container>
                    </select>

                    <input  class="form-control  permit-select" id="idCtype" value="{{defaultValueType}}" [disabled]="true" *ngIf="duration"/>
                  </div>
                </div>
              </div>

              <div *ngIf="showcarapplist">
                <p>You have already received {{maxallowedpermits-1}} of this type of permit. You may only apply for {{maxallowedpermits}} of this type of permit if you have submitted an equivalent long-term permit application. Please select the relevant long-term application from the list below.</p>
                <table class="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Application Number</th>
                      <th>Account Name</th>
                      <th>Permit Type </th>
                      <th>Permit Start Date</th>
                      <th>Permit End Date</th>
                      <th>Permit Staus</th>
                      <th>Application Date</th>

                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of carrierapplist">
                          <td><input type="radio" name="carrierapplist"  (change)="selectedApplication($event,item)" /></td>
                        <td>{{item.appid}}</td>
                        <td>{{item.permitnum}}</td>
                        <td>{{item.permtype}}</td>
                        <td>{{item.permstartdate}}</td>
                        <td>{{item.permenddate}}</td>
                        <td>{{item.permstatus}}</td>
                        <td>{{item.appdate}}</td>
                        </tr>
                      </tbody>

               </table>
               <!-- <div *ngIf="selectedappid != 0">
                <button title="Add Application" type="button" id="btnBack" (click)="addlongapp()"
                  class="btn btn-md btn-primary pull-left addSelected" style="margin-left:10px; ">Add selected to
                  application</button>
              </div> -->
              </div>

            </div>
            <br>
            <!-- <div class="row form-group">
            <div class="col-sm-3">
              <label ><strong>My Reference : </strong></label>
           </div>
            <div class="col-sm-8">
              <input type="text"  #reference  [value]="referenceNum" ([ngModel])="referenceNum"  (keyup)="myRef(reference.value)" class="reference-input">
           </div>
         </div> -->
          </div>
          <!-- <div class="col-sm-6">
          <div class="col-md-12"><h1><span style="font-size:20px">How to apply for a permit</span></h1>

            <ol>
              <li>Select the application type in the list on the left (see below for details).</li>
              <li>Provide a reference or purchase order numberfor your use.</li>
              <li>Click the start buttom on bottom right of screen.</li>
              <li>From then on you can switch from tab to tab as you wish.</li>
              <li>When you have completed the application, press the submit button.</li>
            </ol>
            </div>

      </div> -->

        </div>
      </div>
    </div>
    <!-- <div *ngIf="!reloadVehicle">
      <app-app-vehicle [dataCntrl]="dataCntrl"></app-app-vehicle>
    </div>
    <div *ngIf="reloadVehicle">
      <app-app-vehicle [dataCntrl]="dataCntrl"></app-app-vehicle>
    </div> -->


  </div>
  <ng-container *ngIf="isProcess">
<button
class="btn btn-md m-clr pull-right hd-btn"
(click)="cancelApplication()" title="Cancel" [disabled]="disableBtn"  style="float: right !important;">
 Cancel</button>
<button
class="btn btn-md m-clr pull-right hd-btn mr-2"
(click)="saveApplication()" [disabled]="disableBtn || canSave==false" title="Save & Continueto step 2" style="float: right !important;">
 Save & Continue</button>
<div *ngIf="disableBtn" >
<button
class="btn btn-md m-clr pull-right hd-btn mr-2"
(click)="cancelApplication()" title="Cancel"  style="float: right !important;">
<!-- routerLink="/permit/approval" title="Cancel"  style="float: right !important;"> -->
 Back</button>
</div>
</ng-container>
